module.exports={render:function (){with(this) {
  return _m(0)
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "container mainContent"
  }, [_h('h2', ["Test Page"]), " ", _h('p', ["You could have some other content here!"])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/testpage.vue
 ** module id = 93
 ** module chunks = 2
 **/